export default __webpack_public_path__ + "static/media/verify-email-illustration.11deedd7.svg";